import { makeRequest } from "./api";

export const FetchSafeties = async () => {
  return makeRequest("/api/admin/safety/fetch");
};

export const CreateSafety = async (formData) => {
  return makeRequest("/api/admin/safety/create", {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const UpdateSafety = async (formData) => {
  return makeRequest("/api/admin/safety/update", {
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const DeleteSafety = async (safetyId) => {
  return makeRequest(`/api/admin/safety/remove/${safetyId}`, {
    method: "DELETE",
  });
};
